import { Link } from "wouter";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { X, Music } from "lucide-react";
import { ThemeToggle } from "@/components/ui/theme-toggle";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="right" className="p-0">
        <div className="flex flex-col h-full">
          <div className="flex justify-between items-center p-4 border-b border-border">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black dark:text-white">
                <Music className="h-4 w-4" />
              </div>
              <span className="font-bold text-primary">NoLicense Nearby</span>
            </div>
            <button 
              onClick={onClose}
              className="p-2 rounded-full hover:bg-accent"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <div className="flex-1 overflow-auto">
            <nav className="p-4">
              <ul className="space-y-3">
                <li>
                  <Link href="/catalog">
                    <span 
                      className="block font-medium text-foreground hover:text-primary py-2 cursor-pointer"
                      onClick={onClose}
                    >
                      Catalog
                    </span>
                  </Link>
                </li>
                <li>
                  <Link href="/pricing">
                    <span 
                      className="block font-medium text-foreground hover:text-primary py-2 cursor-pointer"
                      onClick={onClose}
                    >
                      Pricing
                    </span>
                  </Link>
                </li>
                <li>
                  <Link href="/license">
                    <span 
                      className="block font-medium text-foreground hover:text-primary py-2 cursor-pointer"
                      onClick={onClose}
                    >
                      License Music
                    </span>
                  </Link>
                </li>
                <li>
                  <Link href="/about">
                    <span 
                      className="block font-medium text-foreground hover:text-primary py-2 cursor-pointer"
                      onClick={onClose}
                    >
                      About
                    </span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          
          <div className="p-4 border-t border-border flex flex-col space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Toggle Dark Mode</span>
              <ThemeToggle />
            </div>
            
            <Link href="/license">
              <span 
                className="block w-full py-3 px-4 bg-primary text-black dark:text-white font-medium rounded-lg text-center cursor-pointer"
                onClick={onClose}
              >
                License Music
              </span>
            </Link>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
